import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

import { WikiLiveRail } from "./WikiLiveRail";

function SidebarLinks({ categories = [] }) {
  return (
    <div className="space-y-2">
      {categories.map((category) => (
        <Link
          key={category.id}
          data-testid={`wiki-category-link-${category.slug}`}
          to={`/wiki/${category.slug}`}
          className="block border border-zinc-800 bg-zinc-950/60 px-3 py-3 text-sm text-zinc-200 hover:border-amber-700/40 transition-colors"
        >
          <div className="font-cinzel text-sm text-amber-100">{category.title}</div>
          <div className="mt-1 text-xs text-zinc-500 leading-relaxed">{category.description}</div>
        </Link>
      ))}
    </div>
  );
}

export function WikiChrome({ title, subtitle, categories = [], quickLinks = [], liveSidebar = {}, action = null, children }) {
  return (
    <div data-testid="wiki-chrome" className="space-y-6 pb-10">
      <section className="border border-amber-900/20 bg-[radial-gradient(circle_at_top_left,rgba(180,120,40,0.18),transparent_45%),linear-gradient(180deg,rgba(31,24,20,0.92),rgba(13,12,11,0.98))] p-5 sm:p-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-zinc-500">Lanista Archives</div>
            <h1 data-testid="wiki-page-title" className="mt-3 font-cinzel text-4xl sm:text-5xl lg:text-6xl text-amber-100">{title}</h1>
            {subtitle && <p data-testid="wiki-page-subtitle" className="mt-3 max-w-3xl text-sm sm:text-base text-zinc-300 leading-relaxed">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <Sheet>
              <SheetTrigger asChild>
                <Button data-testid="wiki-mobile-sections-trigger" variant="outline" className="lg:hidden border-amber-700/40 bg-zinc-950/60 text-amber-100 hover:bg-zinc-900/80">Browse Sections</Button>
              </SheetTrigger>
              <SheetContent side="left" className="border-zinc-800 bg-zinc-950 text-zinc-100">
                <SheetHeader>
                  <SheetTitle className="font-cinzel text-amber-100">Wiki Sections</SheetTitle>
                </SheetHeader>
                <div className="mt-6 overflow-y-auto pr-1">
                  <SidebarLinks categories={categories} />
                </div>
              </SheetContent>
            </Sheet>
            {action}
          </div>
        </div>
      </section>

      <div className="grid gap-6 xl:grid-cols-[18rem_minmax(0,1fr)_18rem]">
        <aside className="hidden xl:block">
          <div className="sticky top-24 space-y-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-zinc-500">Sections</div>
            <SidebarLinks categories={categories} />
          </div>
        </aside>

        <main data-testid="wiki-main-content" className="min-w-0 space-y-6">
          {children}
        </main>

        <aside>
          <div className="sticky top-24">
            <WikiLiveRail quickLinks={quickLinks} liveSidebar={liveSidebar} />
          </div>
        </aside>
      </div>
    </div>
  );
}